import { ForgotPasswordFormData } from "./types";

export function getForgotPasswordFormDataInitialValues(): ForgotPasswordFormData {
  return {
    email: '',
  };
}
